import { render, staticRenderFns } from "./task-widget.vue?vue&type=template&id=3e4f7e3a&scoped=true&"
import script from "./task-widget.vue?vue&type=script&lang=js&"
export * from "./task-widget.vue?vue&type=script&lang=js&"
import style0 from "./task-widget.vue?vue&type=style&index=0&lang=css&"
import style1 from "./task-widget.vue?vue&type=style&index=1&id=3e4f7e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f7e3a",
  null
  
)

export default component.exports